module.exports = __webpack_public_path__ + "img/formas-pagamento.85c97945.png";